module.exports = __webpack_public_path__ + "static/img/ldtbj.png";